import { useEffect, useState } from "react";
import { api } from "../../../shared/api/client";
import { Empty, Loading } from "../../../shared/components/Empty";
import { Pill } from "../../../shared/components/Pill";
import { toast } from "../../../shared/stores/toasts";

type Endpoint = { id: number; name: string; url: string; events: string[]; secret: string; is_active: boolean };

const EVENT_OPTIONS = [
  "approval.completed", "approval.rejected", "contract.expiring",
  "employee.onboarded", "employee.retired", "payroll.published", "journal.posted",
];

export function AdminWebhooks() {
  const [items, setItems] = useState<Endpoint[] | null>(null);
  const [form, setForm] = useState({ name: "", url: "", events: [] as string[] });
  const reload = () => api.get<Endpoint[]>("/admin/webhooks").then((r) => setItems(r.data));
  useEffect(() => { reload(); }, []);

  const create = async () => {
    try { await api.post("/admin/webhooks", form); toast.success("등록됨"); setForm({ name: "", url: "", events: [] }); reload(); }
    catch (e: any) { toast.error("실패", e?.response?.data?.error?.message); }
  };
  const del = async (id: number) => {
    if (!confirm("삭제하시겠습니까?")) return;
    await api.delete(`/admin/webhooks/${id}`); reload();
  };
  const toggleEvent = (ev: string) => setForm((f) => ({ ...f, events: f.events.includes(ev) ? f.events.filter((e) => e !== ev) : [...f.events, ev] }));

  return (
    <div className="t-grid cols-1">
      <div className="t-card">
        <h3 style={{ margin: "0 0 12px" }}>Webhook 추가</h3>
        <div style={{ display: "grid", gap: 12 }}>
          <input className="t-input" placeholder="이름" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })}/>
          <input className="t-input" placeholder="https://example.com/webhook" value={form.url} onChange={(e) => setForm({ ...form, url: e.target.value })}/>
          <div style={{ display: "flex", flexWrap: "wrap", gap: 6 }}>
            {EVENT_OPTIONS.map((ev) => (
              <button key={ev} className="t-btn t-btn-sm" style={{ background: form.events.includes(ev) ? "var(--p-tint)" : "var(--panel)", color: form.events.includes(ev) ? "var(--p-700)" : "var(--text-2)" }} onClick={() => toggleEvent(ev)}>
                {ev}
              </button>
            ))}
          </div>
          <button className="t-btn t-btn-primary" onClick={create} disabled={!form.name || !form.url}>등록</button>
        </div>
      </div>

      {items === null && <Loading/>}
      {items?.length === 0 && <Empty msg="등록된 Webhook이 없습니다"/>}
      <div className="t-card" style={{ padding: 0 }}>
        <div className="t-list" style={{ padding: 16 }}>
          {items?.map((e) => (
            <div key={e.id} className="t-row">
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600 }}>{e.name}</div>
                <div style={{ fontSize: 11, color: "var(--text-3)" }}>{e.url}</div>
                <div style={{ display: "flex", gap: 4, marginTop: 4, flexWrap: "wrap" }}>
                  {e.events.map((ev) => <Pill key={ev} kind="info">{ev}</Pill>)}
                </div>
              </div>
              <Pill kind={e.is_active ? "ok" : "muted"}>{e.is_active ? "활성" : "비활성"}</Pill>
              <button className="t-btn t-btn-sm" onClick={() => del(e.id)}>삭제</button>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
